import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MemoryPipelineComponent } from './memory-pipeline.component';
import { CanvasEngineModule, InputSystem, PhysicsManager } from '@adaptiva/canvas';
import { ResizeSensorComponentModule } from '../../resize-sensor';

@NgModule({
	imports: [
		CommonModule,
		CanvasEngineModule.forRoot([]),
		ResizeSensorComponentModule,
	],
	declarations: [
		MemoryPipelineComponent,
	],
	providers: [
		InputSystem.Cursor,
		InputSystem.Keyboard,
		PhysicsManager,
		{
			provide: InputSystem.KEYBINDS_TOKEN,
			useValue: {
				ToggleDebug: [
					new InputSystem.Keybind('`', ['control'])
				]
			}
		},
		{
			provide: InputSystem.KEY_ALIASES_TOKEN,
			useValue: new Map()
		}
	],
	exports: [MemoryPipelineComponent],
})
export class MemoryPipelineComponentModule {

}
